export default __webpack_public_path__ + "static/media/jaisalmer1.2b8de7c2.jpg";